import { render, staticRenderFns } from "./EmbeddedGallery.vue?vue&type=template&id=1a07935b&scoped=true"
import script from "./EmbeddedGallery.vue?vue&type=script&lang=js"
export * from "./EmbeddedGallery.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedGallery.vue?vue&type=style&index=0&id=1a07935b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07935b",
  null
  
)

export default component.exports